import { useRecoilState } from 'recoil'
import { listPointState, selectedPoint } from 'store/buildingStore'
import Krpano from 'utils/krpano'

type KrpanoSimpleInitProps = {
  imageUrl: string
  previewUrl?: string
  h: number
  v: number
  z: number
  tilesUrl?: string
  multires?: string
}

export default function useModalViewKrpano() {
  const [currentSelectedPoint] = useRecoilState(selectedPoint)
  const [points] = useRecoilState(listPointState)

  const embedpanoModal = (
    KrpanoSimpleInitProps: KrpanoSimpleInitProps,
    targetId: string
  ) => {
    const {
      imageUrl,
      previewUrl = '',
      h,
      v,
      z,
      tilesUrl = '',
      multires
    } = KrpanoSimpleInitProps

    ;(window as any).embedpano({
      id: `${targetId}-pano`,
      xml: '/krpano/xml-assets/pano_preview.xml',
      target: targetId,
      html5: 'auto+webgl',
      mwheel: false,
      bgcolor: '#FFFFFF',
      onready: (krpano: any) => {
        try {
          const sceneName = Krpano.getScenceNameByFileId(
            currentSelectedPoint,
            points,
            undefined
          )
          const screenString = Krpano.generateSceneXML({
            sceneName,
            tilesUrl: tilesUrl || undefined,
            multires: multires || undefined,
            s3Path: imageUrl,
            thumbnailUrl: previewUrl || ''
          })

          krpano.call(`loadxml(${screenString}, null, MERGE);`)

          krpano.call(
            `loadscene(${sceneName}, null, MERGE, 'simple crossblending');`
          )

          krpano.call(`set(initzoom,${z});`)
          krpano.call(`lookat(${h}, ${v}, ${z}, 0)`)
          krpano.call('removelayer(control_btn_zoom)')
          krpano.call('removelayer(control_btn_out)')
          krpano.call('removelayer(control_btn_hp)')
          if (targetId === 'preview-krpano-container-main') {
            krpano.call(`set(control.usercontrol, off);`)
          } else {
            krpano.call('set(control.mouse, on);')
            krpano.call('set(control.touch, on);')
            krpano.call('set(control.keyboard, on);')
          }
          const waitForLoadComplete = () => {
            if (krpano.get('loadcomplete') === 'true') {
              krpano.set('view.limitview', 'lookat')
              krpano.set('view.vlookatmin', v)
              krpano.set('view.vlookatmax', v)
            } else {
              setTimeout(waitForLoadComplete, 100)
            }
          }
          waitForLoadComplete()
        } catch (err) {}
      }
    })
  }

  return {
    embedpanoModal
  }
}
